(() => {
/* 
* WP Theme custom scripts 
*/ // import { Calculator } from './partials/_pastuerisation-calculator';
document.addEventListener("DOMContentLoaded", function() {
    var $ = jQuery.noConflict(), swiper, testimonials, technical, sectors;
    // Default Row Slider section
    $(".wp-block-tfa-row-section.slider-section > .row").addClass("swiper-wrapper");
    $(".wp-block-tfa-row-section.slider-section > .row > .wp-block-tfa-column").addClass("swiper-slide");
    $(".wp-block-tfa-row-section.slider-section").append('<div class="swiper-slider-section-nav"><div class="swiper-button-prev"></div><div class="swiper-pagination"></div><div class="swiper-button-next"></div></div>');
    setTimeout(function() {
        swiper = new Swiper(".wp-block-tfa-row-section.slider-section", {
            observeSlideChildren: true,
            slideToClickedSlide: true,
            updateOnWindowResize: true,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                760: {
                    slidesPerView: 1
                },
                992: {
                    slidesPerView: 3
                }
            },
            autoplay: {
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false
            },
            pagination: {
                el: ".swiper-slider-section-nav .swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".swiper-slider-section-nav .swiper-button-next",
                prevEl: ".swiper-slider-section-nav .swiper-button-prev"
            },
            grabCursor: true
        });
    }, 500);
    // Run Swiper slider for section only Tablet Up
    //$('.section__special-services .swiper-slider-section-nav').remove();
    $(".section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section").append('<div class="swiper-slider-section-nav"><div class="swiper-button-prev"></div><div class="swiper-pagination"></div><div class="swiper-button-next"></div></div>');
    var specServicesSlider = function() {
        if (window.innerWidth >= 768) {
            $(".section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section").addClass("slider-section");
            $(".section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section > .row").addClass("swiper-wrapper");
            $(".section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section > .row > .wp-block-tfa-column").addClass("swiper-slide");
            $(".section__special-services .swiper-slider-section-nav").show();
            setTimeout(function() {
                var swiperSpecServ = new Swiper(".section__special-services .row.one-column-layout > .wp-block-tfa-column > .row", {
                    slideToClickedSlide: true,
                    spaceBetween: 0,
                    loop: false,
                    breakpoints: {
                        768: {
                            slidesPerView: 2
                        },
                        992: {
                            slidesPerView: 3
                        }
                    },
                    autoplay: {
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: false
                    },
                    pagination: {
                        el: ".swiper-slider-section-nav .swiper-pagination",
                        clickable: true
                    },
                    navigation: {
                        nextEl: ".swiper-slider-section-nav .swiper-button-next",
                        prevEl: ".swiper-slider-section-nav .swiper-button-prev"
                    },
                    grabCursor: true
                });
            }, 500);
        } else {
            $(".section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section > .row").removeClass("swiper-wrapper");
            $(".section__special-services .row.one-column-layout > .wp-block-tfa-column > .wp-block-tfa-row-section > .row > .wp-block-tfa-column").removeClass("swiper-slide");
            $(".section__special-services .swiper-slider-section-nav").hide();
        }
    };
    specServicesSlider();
    window.addEventListener("resize", function(event) {
        specServicesSlider();
    }, true);
    // Related pages & posts
    swiper = new Swiper(".related-pages.swiper-slider, .related-posts.swiper-slider", {
        observeSlideChildren: true,
        slideToClickedSlide: true,
        updateOnWindowResize: true,
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            760: {
                slidesPerView: 2
            },
            992: {
                slidesPerView: 3
            }
        },
        autoplay: {
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: false
        },
        pagination: {
            el: ".swiper-slider-related-nav .swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".swiper-slider-related-nav .swiper-button-next",
            prevEl: ".swiper-slider-related-nav .swiper-button-prev"
        },
        grabCursor: true
    });
    testimonials = new Swiper(".testimonials-slider", {
        observeSlideChildren: true,
        slideToClickedSlide: true,
        updateOnWindowResize: true,
        slidesPerView: 4,
        spaceBetween: 30,
        autoHeight: true,
        loop: true,
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            760: {
                slidesPerView: 2
            },
            992: {
                slidesPerView: 4
            }
        },
        autoplay: {
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: false
        },
        pagination: {
            el: ".testimonials-slider--nav .swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".testimonials-slider--nav .swiper-button-next",
            prevEl: ".testimonials-slider--nav .swiper-button-prev"
        },
        grabCursor: true
    });
    technical = new Swiper(".technicals-slider", {
        observeSlideChildren: false,
        slideToClickedSlide: true,
        updateOnWindowResize: true,
        slidesPerView: 1,
        spaceBetween: 30,
        autoHeight: true,
        loop: true,
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            760: {
                slidesPerView: 1.3
            },
            992: {
                slidesPerView: 2.3
            }
        },
        autoplay: {
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: false
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        grabCursor: true
    });
    sectors = new Swiper(".sectors-slider", {
        observeSlideChildren: false,
        slideToClickedSlide: true,
        updateOnWindowResize: true,
        slidesPerView: 1,
        spaceBetween: 30,
        autoHeight: true,
        loop: true,
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            760: {
                slidesPerView: 1.3
            },
            992: {
                slidesPerView: 2.3
            }
        },
        autoplay: {
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: false
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        grabCursor: true
    });
});


document.addEventListener("DOMContentLoaded", function() {
    var $ = jQuery.noConflict(), win = $(window).width(), d = new Date(), n = d.getFullYear(), page = $("html, body"), pageUrl = window.location.href, i = 0;
    $(".foo__copy em").text(n).addClass("foo__copy-year");
    // WP Remove <p> tags
    $("div.row p:empty").hide();
    /**
	* Menu Scroll
	*/ var lastScrollTop = 0;
    $(window).scroll(function(e) {
        var scroll = $(window).scrollTop();
        var HeroHeader = $(".sticky-header");
        var st = $(this).scrollTop();
        if (scroll >= 0) $(HeroHeader).addClass("onScroll");
        else $(HeroHeader).removeClass("onScroll");
        if (st > lastScrollTop) $(HeroHeader).removeClass("onScrollUp");
        else $(HeroHeader).addClass("onScrollUp");
        lastScrollTop = st;
        if (scroll >= 94) {
            $(".scroll-up").removeClass("hidden");
            $(".site-header").addClass("static");
            $(".list-menu").addClass("sticky");
        } else {
            $(".scroll-up").addClass("hidden");
            $(".site-header").removeClass("static");
            $(".list-menu").removeClass("sticky");
        }
    });
    setTimeout(function() {
        $(".acf-form-sent").text("");
        if ($(".acf-form-sent").hasClass("acf-form-sent")) history.replaceState(null, null, " ");
    }, 2000);
    // Scroll Up button
    $(".scroll-up").click(function(e) {
        page.animate({
            scrollTop: 0
        }, 100);
        e.preventDefault();
    });
    // Scroll Down button
    $(".scroll-down").click(function(e) {
        var SlideHeight = $(".hero-home").height();
        // /console.log(SlideHeight);
        page.animate({
            scrollTop: page.scrollTop() + SlideHeight
        }, 100);
        e.preventDefault();
    });
    /**
	 * Mobile Menu Toggle
	 */ $(".navbar-toggler-btn").on("click", function() {
        $("body").toggleClass("menu-open");
    });
    $(".header-nav-overlay").on("click", function() {
        $(".navbar-toggler-btn").trigger("click");
    });
    $(".nav-covers, .nav-covers a").on("click", function() {
        $(".pop-menu li, .dynamic-row .wp-block-tfa-column").removeClass("active");
        setTimeout(function() {
            $(".nav-covers").addClass("active");
        }, 500);
    });
    $(".nav-resources, .nav-resources a").on("click", function() {
        $(".pop-menu li, .dynamic-row .wp-block-tfa-column").removeClass("active");
        setTimeout(function() {
            $(".nav-resources").addClass("active");
        }, 500);
    });
    $(".nav-about, .nav-about a").on("click", function() {
        $(".pop-menu li, .dynamic-row .wp-block-tfa-column").removeClass("active");
        setTimeout(function() {
            $(".nav-about").addClass("active");
        }, 500);
    });
    $("nav.header-nav.megamenu a").on("click", function() {
        setTimeout(function() {
            $("#fancybox-overlay").addClass("orange-bg");
        }, 200);
    });
    // Megamenu: forward clicks on the chevron/checkbox to the sibling link,
    // so the arrow area opens the megamenu just like clicking the item text.
    $("nav.header-nav.megamenu .nav-item > input.item-sub, nav.header-nav.megamenu .nav-item > em").on("click", function(e) {
        e.preventDefault();
        $(this).closest(".nav-item").children("a").trigger("click");
    });
    $(".wc-block--included-services__content a.fancybox-inline svg").on("click", function() {
        $("#fancybox-overlay").removeClass("orange-bg");
    });
    $(window).resize(function() {
        $(".tfa-header-menu-container .navbar-nav input").prop("checked", false);
    });
    // Variations as Radio Buttons on radio button change(click)
    $(document).on("change", ".tfa-variation-radios input", function() {
        // for each checked radio button we reflect the same changes to select dropdowns
        $(".tfa-variation-radios input:checked").each(function(index, element) {
            const radio = $(element);
            const radioName = radio.attr("name");
            const radioValue = radio.attr("value");
            $('select[name="' + radioName + '"]').val(radioValue).trigger("change");
        });
    });
    $(".woocommerce.wc-block-catalog-sorting select.orderby option:last-child").remove();
    $(".navbar-nav .nav-covers, .navbar-nav .nav-resources, .navbar-nav .nav-about").addClass("fancybox-inline");
    $(".tfa-header-menu-container .navbar-nav>.menu-item a").each(function() {
        var target = $(this).attr("href");
        if (pageUrl === target) $(this).parent(".nav-item").addClass("menu-item-current");
        else $(this).parent(".nav-item").removeClass("menu-item-current");
    });
    $(".wpcf7-select, .acf-form select, .wc-block-catalog-sorting .orderby, .wc-block-components-sort-select__select, .wc-block-product-categories__dropdown select").select2({
        minimumResultsForSearch: 20
    });
    $("body").on("wpcf7-field-groups/added", function(e, g) {
        let $select = $(g).find(".wpcf7-select");
        $select.each(function(i, select) {
            $(select).removeClass("select2-hidden-accessible").removeAttr("data-select2-id").siblings(".select2-container").remove();
            $(select).select2({
                minimumResultsForSearch: 20
            });
        });
    });
    var postTitle = $("meta[property='og:title']").attr("content");
    var postContent = postTitle + " - " + pageUrl;
    $('.bssbSocialShare li.icon[data-social="mail"]').click(function() {
        window.location = "mailto:?subject=" + postTitle + "&body=" + postContent;
    });
    $(".popup-menu ul.is-style-tick-list li a").click(function() {
        $(".popup-menu").hide();
    });
    // Remove empty p & style tags
    $("div").each(function() {
        if ($(this).attr("style") === "") $(this).removeAttr("style");
    });
    if (window.location.href.indexOf("brochure-download") > -1) $(".hero-wrap").hide();
    $(".img-cover img").each(function(i, elem) {
        var h = $(this).parents(".img-cover").siblings().height() + 200;
        var img = $(elem);
        img.css("height", h);
    });
    // ACF Accordion multi items unique IDs for each item if more then 1 per page
    var accordion = $("body .section_acf-flexible-items > .accordion").length;
    if (accordion > 1) $(".section_acf-flexible-items >.accordion").each(function(a) {
        a++;
        var id = $(this).attr("id");
        $(this).attr("id", id + "-" + a);
        $(this).find(".accordion-item").each(function(item) {
            item++;
            var target = $(this).find(".accordion-button").attr("data-bs-target");
            $(this).find(".accordion-button").attr("data-bs-target", target + "-" + item + a);
            var controls = $(this).find(".accordion-button").attr("aria-controls");
            $(this).find(".accordion-button").attr("aria-controls", controls + "-" + item + a);
            var item_id = $(this).find(".collapse").attr("id");
            $(this).find(".collapse").attr("id", item_id + "-" + item + a);
            var item_parent = $(this).find(".collapse").attr("data-bs-parent");
            $(this).find(".collapse").attr("data-bs-parent", item_parent + "-" + item + a);
        });
    });
    $(".accordion-button").addClass("collapsed");
    // Filter by Cat UI close btn
    $(".wpc-filter-content.wpc-filter-product_cat").trigger("click");
    $(document).on("click", ".wpc-filter-content.wpc-filter-product_cat", function() {
        $(".wpc-filter-product_cat button").trigger("click");
    });
    //Cover & Cover finder page reload after filter for Fancybox popup path reload
    $(document).on("click", "body.woocommerce-shop .wpc-filters-ul-list li, body.cover-finder .wpc-filter-layout-submit-button, .wpc-chip-reset-all", function() {
        setTimeout(function() {
            $(".fancybox-inline").fancybox();
        }, 1200);
    });
    // First child variations always checked (radio btn)
    $("table.variations .tfa-variation-radios").each(function() {
        $(this).find("label:first").trigger("click");
    });
    // Hide variations if only area and one price
    $("#attribute_pa_area-europe,  #attribute_pa_area-uk").trigger("click");
    $(".section__updates .wp-block-query ul.wp-block-post-template").append('<li class="wp-block-post--ask-box"><a href="#q">Frequently Asked <br>Questions</a></li>');
    $("#attribute_pa_quantity-4").next("label").append('<a href="../../product-tag/4th-free/" rel="tag" class="nth-car free">4th free</a>');
    // Single Product Price variables
    var n_price = $("body.single-product .col-lg-5 .wc-block-grid__product-price").children("span.woocommerce-Price-amount.amount").length;
    $("#attribute_pa_pay-monthly-or-yearly").parent().addClass("attribute_pa_pay-monthly-or-yearly");
    setTimeout(function() {
        $("body.single-product .attribute_pa_pay-monthly-or-yearly, body.single-product #attribute_pa_area, body.single-product #attribute_pa_assistance-at-home-address").parent().addClass("hidden");
    }, 500);
    $("#attribute_pa_pay-monthly-or-yearly-monthly").trigger("click");
    if ($("body.single-product .attribute_pa_pay-monthly-or-yearly").length == 0) $(".product-price-switch .form-check-input, .product-price-switch .monthly, .product-price-switch .form-check-label.info").hide();
    $(".form-switch").on("click", function() {
        if ($("input#flexSwitchCheckChecked").is(":checked")) $("#attribute_pa_pay-monthly-or-yearly-monthly").click();
        else $("#attribute_pa_pay-monthly-or-yearly-yearly").click();
    });
    $("body").on("click change", "form.variations_form.cart", function() {
        if ($(".single_variation_wrap .single_variation div").length) $(".single-product .wp-block-tfa-column.col-lg-5").addClass("active");
        if (n_price <= "1") $(".single-product .wp-block-tfa-column.col-lg-5").removeClass("active");
    });
    $(".reset_variations").on("click", function() {
        $(".single-product .wp-block-tfa-column.col-lg-5").removeClass("active");
    });
    function Tags() {
        $(".taxonomy-product_tag a").each(function() {
            var class_name = $(this).text().toLowerCase().replace(/\d+/g, "n").replace(" ", "-");
            $(this).addClass(class_name);
        });
    }
    Tags();
    $("body").on("click change", ".wp-block-query", function() {
        Tags();
    });
    // Tabs
    var id = $(".section__tabs--content").attr("id");
    $(".section__tabs ul.nav li").removeClass("active");
    $(".section__tabs ul.nav li").each(function() {
        i++;
        $(this).addClass("tab-id-" + i);
        $(this).children("a").attr("data-tab", "#tab-id-" + i);
        var cl = $(this).attr("class");
        if ($(this).hasClass(id)) $(this).addClass("active");
    });
    /**
	 * ACF Blocks TABS
	 */ const tabs = document.querySelectorAll("[data-tab-target]");
    const tabContents = document.querySelectorAll("[data-tab-content]");
    $(tabs).each(function(i, tab) {
        $(tab).on("click", function() {
            const target = $(this).attr("data-tab-target");
            $(tabContents).each(function(i, tabContent) {
                $(tabContent).removeClass("active");
            });
            $(tabs).each(function(i, tab) {
                $(tab).removeClass("active");
            });
            $(tab).addClass("active");
            $(target).addClass("active");
            $(tabContents).each(function(tabContent) {
                const targetContent = $(this).attr("data-tab-content");
                if (targetContent == target) {
                    let activeContent = document.getElementById(target);
                    $(activeContent).addClass("active");
                }
            });
        });
    });
    /**
	 * Mobile Menu Toggle
	 */ if ($("body").hasClass("menu-open")) $("body").removeClass("menu-open");
    else $("body").toggleClass("menu-open");
    $("body").removeClass("menu-open");
    $(".header-nav-overlay").on("click", function() {
        $("body").removeClass("menu-open");
    });
    $(window).resize(function() {
        $(".tfa-header-menu-container .navbar-nav input").prop("checked", false);
    });
    $(".tfa-header-menu-container .navbar-nav>.menu-item a").each(function() {
        var target = $(this).attr("href");
        if (pageUrl === target) $(this).parent(".nav-item").addClass("menu-item-current");
        else $(this).parent(".nav-item").removeClass("menu-item-current");
    });
    /**
	 * Switcher Dark Mode
	 */ const darkTheme = "dark-theme";
    const darkThemeSetUp = ()=>{
        if (getCurrentTheme() === "dark") document.getElementById("toggleBtn").checked = true;
        else document.getElementById("toggleBtn").checked = false;
    };
    const getCurrentTheme = ()=>document.body.classList.contains(darkTheme) ? "dark" : "light";
    const selectedTheme = localStorage.getItem("selected-theme");
    if (selectedTheme === "dark") {
        document.body.classList[selectedTheme === "dark" ? "add" : "remove"](darkTheme);
        darkThemeSetUp();
    }
    const themeButton = document.getElementById("toggleBtn");
    if ($("body").hasClass("light-dark")) {
        // console.log('btn active');
        $(".switcher-darkmode").css("display", "block");
        themeButton.addEventListener("change", ()=>{
            document.body.classList.toggle(darkTheme);
            localStorage.setItem("selected-theme", getCurrentTheme());
            darkThemeSetUp();
        });
    } else // console.log('btn not active');
    $(".switcher-darkmode").css("display", "none");
    /**
	 * Switching Cart
	 */ if ($("body").hasClass("woo-cart")) $(".wp-block-woocommerce-mini-cart").css({
        "display": "flex",
        "opacity": "1"
    });
    else $(".wp-block-woocommerce-mini-cart").css("display", "none");
    /**
	 * Switching Account Btn
	 */ if ($("body").hasClass("woo-account")) $(".block-account").css({
        "display": "flex",
        "opacity": "1"
    });
    else $(".block-account").css("display", "none");
    /**
	 * Switching Flags Btn
	 */ if ($("body").hasClass("menu-flags")) $(".block-polylang").css({
        "display": "flex",
        "opacity": "1"
    });
    else $(".block-polylang").css("display", "none");
    if ($("body nav.header-nav").hasClass("megamenu")) $(".navbar-toggler-btn").css({
        "display": "none"
    });
    else $(".navbar-toggler-btn").css({
        "display": "block"
    });
    /**
	 * Form Range field
	 */ var rangeSlider = function() {
        var slider = $(".range-slider"), range = $(".range-slider__range"), value = $(".range-slider__value");
        slider.each(function() {
            value.each(function() {
                var value = $(this).prev().attr("value");
                $(this).html(value).val(value);
            });
            range.on("input", function() {
                $(this).next(value).html(this.value);
                $(this).attr("value", this.value);
            });
        });
    };
    rangeSlider();
});




 // document.addEventListener("DOMContentLoaded", function() {
 //     const calculators = document.querySelectorAll('.calculator-pasteurisation');
 //     calculators.forEach((calculator) => {
 //         let form = calculator.querySelector('form');
 //         let newCalculator = new Calculator(form);
 //     })
 // });

})();
//# sourceMappingURL=tfa-theme-main.js.map
